import { PrimaryButtonAnchor } from "components/ui/button-link";
import { defaultLinkStyle } from "components/ui/link";
import React from "react";
import { useSupportEmailAddress } from "store/selectors/branding";

interface SupportEmailLinkProps {
    label?: string;
    subject?: string;
}

const useSupportEmailHref = (subject: string | undefined): string => {
    const mailTo = `mailto:${useSupportEmailAddress()}`;
    return subject ? `${mailTo}?subject=${encodeURIComponent(subject)}` : mailTo;
};

export const SupportEmailLink: React.FC<SupportEmailLinkProps> = props => {
    const { label, subject } = props;
    const supportEmail = useSupportEmailAddress();
    const href = useSupportEmailHref(subject);

    return (
        <a className={defaultLinkStyle} href={href}>
            {label ?? supportEmail}
        </a>
    );
};

export const SupportEmailButton: React.FC<{ label: string; subject: string }> = ({
    label,
    subject,
}) => {
    const href = useSupportEmailHref(subject);
    return (
        <PrimaryButtonAnchor className="shrink-0" href={href}>
            {label}
        </PrimaryButtonAnchor>
    );
};
